import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "../Navigations/MainNavigation";
import RulesNav from "./Nav";
import Footer from "../Footer";

import styled from "styled-components";
const ContainerMain = styled.div`
  width: 100%;
`;
const Container = styled.div`
  width: 80%;
  height: 2200px;
  padding-top: 100px;
  margin-left: 10%;
`;
const Nav = styled.div`
  width: 20%;
  height: 100%;
  float: left;
`;

const MainContent = styled.div`
  width: 78%;
  float: right;
`;
const Title = styled.h1`
  font-weight: 600;
  font-size: 2em;
  margin: 0;
  padding: 0;
`;
const SubTitle = styled.h2`
  font-weight: 600;
  font-size: 1.2em;
  margin: 30px 0 10px 0;
  padding: 0;
`;
const TextBlock = styled.p`
  color: #636161;
`;
const ListItem = styled.li`
  color: #636161;
  margin: 0 0 10px 0;
`;
function ShopTerms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <ContainerMain>
      <Navigation />
      <Container>
        <Nav>
          <RulesNav />
        </Nav>
        <MainContent>
          <Title>Terms of Service for Sellers/Shops</Title>
          <TextBlock>
            You'll be “Eligible” to register our services only if you fulfill
            the subsequent conditions:
          </TextBlock>
          <ListItem>Several things you'll need to have:</ListItem>
          <ListItem>A physical shop</ListItem>
          <ListItem>
            Android phone (4.2. or newer) or iPhone 4s (or newer){" "}
          </ListItem>
          <ListItem>National ID Card and Passport size photo</ListItem>
          <ListItem>Trade License (optional)</ListItem>
          <ListItem>Delivery man (only for food & grocery)</ListItem>
          <ListItem>
            Bicycle or scooter for delivery (only for food & grocery: optional)
          </ListItem>
          <ListItem>
            We trust that the information (Trade License, NID/Passport/Birth
            Certificate) you provided is correct, current and complete and that
            we shall not be liable if you provide misinformation;
          </ListItem>
          <ListItem>
            Company might take up to 03 (three) operating days for updating the
            technical issues (products uploading & shop’s identity) into the
            system and verification of documents, info given in your account;
          </ListItem>
          <ListItem>
            You would produce an ID and password at the time of registering
            where you're entirely accountable for maintaining the preservation
            and confidentiality of your credentials
          </ListItem>
          <ListItem>
            Your account is non-transferable and isn't capable of being
            oversubscribed to a 3rd party;
          </ListItem>
          <ListItem>
            No partnership, employment, or agency relationship exists between
            you, the Maplun or any third-party supplier as a results of this
            agreement or use of the Service
          </ListItem>
          <SubTitle>Conditions for using services –</SubTitle>
          <TextBlock>
            You must not make any fraud with customers by using this platform.
            You can offer rational, realistic or affordable discounts with
            products. You must not showcase, sell, and advertise any forged,
            nude, stolen or any illegal products on this platform. You must not
            bluff or camouflage with customers. Any fraudulent activity may
            result in legal consequence. You would avail the services subject to
            conditions set by Maplun.com or mutual agreement.
          </TextBlock>
          {/* <SubTitle>Business maximization –</SubTitle>
          <TextBlock>
            The four important activities you should do to maximize your
            business:
          </TextBlock>
          <ListItem>Be always active online in the Maplun.com app;</ListItem>

          <ListItem>Keep the “product price updated” always;</ListItem>
          <ListItem>
            Respond, and Deliver the products quickly to customers;
          </ListItem>
          <ListItem>
            Inform or advertise your “home delivery through Maplun.com” service
            to customers (mouth to mouth, Facebook or other social media by link
            sharing, leaflet, poster, banner or festoon locally) as much as
            possible.
          </ListItem>
          <SubTitle>Payments for using services –</SubTitle>
          <TextBlock>
            You would avail the services subject to pay the fees determined by
            Maplun.com. Any delay of payment or renew will cause interruption of
            services, while we are not responsible for such interruption. You
            must pay on or before the date of your payment.
          </TextBlock> */}
          <SubTitle>Suspension/Cancellation of services –</SubTitle>
          <TextBlock>
            You must not showcase, sell, and advertise any forged, nude, stolen
            or any illegal products on this platform. You must not bluff or
            camouflage with customers. Any fraudulent activity may result in
            legal consequence.
          </TextBlock>
          <TextBlock>
            If you violate any of those terms & conditions, Maplun.com reserves
            the right to deactivate and/or cancel/suspend/blacklist your account
            with no notice or refund, which you shall be alone liable during
            this regard.
          </TextBlock>
          <SubTitle>Promotional offers, discount & rewards -</SubTitle>
          <TextBlock>
            The Maplun or associated third party company can promote promotional
            offers like discount, free, reward etc through different options and
            rates with rationality and relevance. Maplun.com reserves the right
            to make you qualified - whether you're entitled to offers or not. A
            promotion would generally contain the mode, the validity period and
            connected terms and conditions within the offer. Both party must
            oblige the terms and conditions therein.
          </TextBlock>
          <SubTitle>
            Interruption of service due to mobile network or internet connection
            -
          </SubTitle>
          <TextBlock>
            We shall create all efforts to make sure that requests for services
            in a timely manner. The service or application is subject to
            limitations, delays and different issues inherent within the use of
            the net communications together with your device quality. If your
            device is faulty, not connected, out of date or not functioning, the
            company shall never be accountable for any delays, delivery
            failures, damages or loss ensuing from such issues.
          </TextBlock>
          <SubTitle>Restriction on content of the application -</SubTitle>
          <TextBlock>
            On this platform, all text, graphics, user interfaces, visual
            interfaces, images, trademarks, logos, design and code
            (collectively, “Content”), and arrangement of such content is
            protected by the laws of land (copyright, trademark, and numerous
            laws);
          </TextBlock>
          <TextBlock>
            No content can be traced, reproduced, republished, uploaded, posted,
            publically displayed, encoded, translated, transmitted or
            distributed in any means (including “mirroring”) to the other
            laptop, mobile phone, server, web site or different medium for
            publication or distribution or storage for any purpose without
            previous written consent.
          </TextBlock>
          <SubTitle>Confidentiality -</SubTitle>
          <TextBlock>
            You shall maintain confidentiality of all info, its services,
            products, business affairs, selling and promotion plans or different
            operations of the company and its associated services. We might
            tie-up with third party entities wherever you may be accepted or
            needed to collaborate with such third-party entities.{" "}
          </TextBlock>
          <SubTitle>Limitation of liability -</SubTitle>
          <TextBlock>
            We shall not be responsible for any event arising because of any
            cause including inconvenience of any communication system, data
            speed, sabotage, fire, flood, explosion, epidemic, pandemic, natural
            calamities, turmoil, strikes, government legislation, or
            administrative acts of government;
          </TextBlock>
          <TextBlock>
            Maplun.com and its representatives, officers, employees, agents and
            vendors shall not be responsible for any loss, damage, claim,
            expense, value (including legal costs) or liability arising directly
            or indirectly from your use or non-use of service or your reliance
            upon the service.
          </TextBlock>
          <SubTitle>
            Governing law, jurisdiction and different dispute resolution -
          </SubTitle>
          <TextBlock>
            This agreement shall be ruled by law of Bangladesh. Any dispute,
            action, claim or cause of action arising out of or in reference to
            this agreement or the service shall be subject to the jurisdiction
            of the courts of the country. You agree that this agreement shall be
            subject to prevailing statutory laws of taxes, VAT, duties, and
            other relevant laws of land. You conform to use your best efforts to
            the relevant laws of land.
          </TextBlock>
          <TextBlock>
            Any dispute with respect to quality, quantity, conformance, weight,
            items, price etc of product shall be communicated and resolved with
            the direct customer.
          </TextBlock>
          <SubTitle>Acknowledgment to the Application (web & app) -</SubTitle>
          <TextBlock>
            The terms and conditions (T&Cs) as stipulated hereafter is an
            electronic record and shall represent lawfully enforceable agreement
            (Electronic Agreement) containing Terms of Use of Maplun.com. Your
            use or access to Maplun.com within the application shall be deemed
            to be your acceptance of those T&Cs. You acknowledge and declare
            that you have understood, and accepted with these T&Cs. Maplun.com
            can prescribe to satisfy vendor’s norms or the other info that we
            might view as necessary from time to time.
          </TextBlock>
          <TextBlock>
            If you do not conform to these T&Cs, either whole or partly, and
            want to discontinue the Service, please don't continue or stop
            accessing to Maplun.com. You can share your thoughts at
            support@Maplun.com
          </TextBlock>
          <TextBlock>
            Please make sure that you read and understand the subsequent “Terms
            and Conditions of Maplun.com” before you use Maplun.com Application
            (both web & app).
          </TextBlock>
        </MainContent>
      </Container>
      <Footer />
    </ContainerMain>
  );
}

export default ShopTerms;
